const comments = [
  {
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个网站真的太绝了！之前找八卦要翻好几个APP，现在一个站全搞定，快讯更新速度比微博热搜还快，牛！',
    likes: '2.3k',
    avatar: 'ri-user-3-line',
  },
  {
    name: '娱乐圈观察员',
    time: '5小时前',
    content: '深度实锤栏目的调查文章写得很用心，时间线梳理得清清楚楚，比那些只发标题的营销号强太多了。已安利给所有吃瓜朋友！',
    likes: '1.8k',
    avatar: 'ri-user-3-line',
  },
  {
    name: '匿名网友9527',
    time: '8小时前',
    content: '最爱话题热榜功能，热门标签一目了然。搜索黑料超方便，输入明星名字就能找到所有相关爆料，吃瓜效率翻倍。',
    likes: '956',
    avatar: 'ri-user-3-line',
  },
  {
    name: '八卦研究生',
    time: '12小时前',
    content: '从去年开始用这个平台，见证了无数大瓜的诞生。实锤内容有理有据，不会乱带节奏，是真正讲求证据的吃瓜平台。',
    likes: '1.2k',
    avatar: 'ri-user-3-line',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 bg-primary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">吃瓜评论</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {comments.map((cmt, i) => (
            <div key={i} className="bg-background-50 border border-background-200/70 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-600 shrink-0">
                  <i className={`${cmt.avatar} text-lg`}></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{cmt.name}</div>
                  <div className="text-xs text-foreground-400">{cmt.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{cmt.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{cmt.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}